import { insideEU } from "./CountryUtils";
import { getCurrentSite } from "./SiteUtils";
import { divide, multiply } from "./NumberUtils";
import { accountTypes } from "../components/form/fields/AccountTypeField";

export function showVat(accountType, countryCode) {
  if (accountType === accountTypes.b2b) return false;
  if (countryCode === "SE") return true;
  if (insideEU(countryCode) && accountType === accountTypes.privateAccount)
    return true;
  return false;
}

export const siteVatFactor = (function () {
  switch (getCurrentSite()) {
    case "se":
    case "com":
    default:
      return 1.25;
  }
})();

export const addVat = (basePrice = 0) => {
  return multiply(basePrice, siteVatFactor);
};

export const removeVat = (price = 0) => {
  return divide(price, siteVatFactor);
};
